import { BuildingsIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'
import { EMPTY_VALUE } from '@/constants'

import * as S from './field-list.styled'

export interface FieldRowProps {
  label: string
  value?: React.ReactNode
  /** Shows the PMS-synced indicator next to the label with this text as its tooltip. */
  pmsTooltip?: string
}

export const FieldRow = ({ label, value, pmsTooltip }: FieldRowProps) => (
  <S.Row>
    <S.LabelWrapper>
      <Typography size="text-medium" color="primary500" as="span">
        {label}
      </Typography>
      {pmsTooltip && (
        <Tooltip
          trigger={
            <S.PmsIconWrapper tabIndex={0} role="img" aria-label={pmsTooltip}>
              <Icon icon={BuildingsIcon} size="1.6rem" />
            </S.PmsIconWrapper>
          }
        >
          {pmsTooltip}
        </Tooltip>
      )}
    </S.LabelWrapper>
    <S.Value>{value || EMPTY_VALUE}</S.Value>
  </S.Row>
)

export const FieldList = ({ children }: { children: React.ReactNode }) => (
  <S.List>{children}</S.List>
)
